import { filter, map } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(
    public translateService: TranslateService,
    public titleService: Title,
    public router: Router,
    public activatedRoute: ActivatedRoute
  ) {
    const languages = ['en', 'pl', 'ja', 'uk'];
    this.translateService.addLangs(languages);
    this.translateService.setDefaultLang('en');

    for (const lang of languages) {
      this.translateService.setTranslation(lang, require('../../../shared/i18n/languages/' + lang + '.json'));
    }

    const browserLang = translateService.getBrowserLang();
    this.translateService.use(browserLang.match(/en|pl|ja|uk/) ? browserLang : 'en');
  }

  ngOnInit() {
    // Set dynamic page title
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        const child = this.activatedRoute.firstChild;
        if (child.snapshot.data['title']) {
          return child.snapshot.data['title'];
        }
        return environment.pageTitle.default;
      })
    ).subscribe((ttl: string) => {
      this.titleService.setTitle(ttl);
    });
  }



}
